import { TicketsViewType } from 'routes/Tickets/TicketsViewType'

export function calculateTotalAmountOfTickets(tickets: Record<number, number>): number {
  let amount = 0
  Object.keys(TicketsViewType).forEach((x) => {
    const ticket = tickets[parseInt(x, 10)]
    if (ticket) {
      amount += ticket
    }
  })
  return amount
}
